const KEY_SEPARATOR = '/';
/**
 * @memberof data-references
 * @property {data-references.DataReference} numerator
 * @property {data-references.DataReference} denominator
 */
class NormalizedDataReference {
    /**
     * @param {object} props
     * @param {data-references.DataReference} props.numerator
     * @param {data-references.DataReference} props.denominator
     */
    constructor(props) {
        this.numerator = props.numerator;
        this.denominator = props.denominator;
    }
    /**
     * @property {string}
     */
    get key() {
        return [this.numerator.key, this.denominator.key].join(KEY_SEPARATOR);
    }
    /**
     * @param {DataReference}
     * @return {boolean}
     */
    isEqual(reference) {
        return reference && reference.key === this.key;
    }
    static from(numerator, denominator) {
        return new NormalizedDataReference({ numerator, denominator });
    }
}
export default NormalizedDataReference;
